<div id="skills" style="position: absolute; top: -100px"></div>
<div class="skills-content">
  <div class="skillsIcons">
    <div class="skillIconBox" *ngFor="let item of imageList">
      <div class="icon">
        <img [src]="item.image" [alt]="item.title" />
      </div>
      <p>
        {{
          item.title === "LEARNING"
            ? ("SKILLS.LEARNING" | translate)
            : item.title
        }}
      </p>
    </div>
  </div>
  <div class="skillsText">
    <div class="skillsTextTitle">
      <h2>{{ "SKILLS.TITLE" | translate }}</h2>
      <div class="strokeSkills"></div>
    </div>
    <div class="skillsTextContent">
      <p [innerHTML]="'SKILLS.DESCRIPTION' | translate"></p>
      <a href="#contact">
        <button>{{ "SKILLS.BUTTON" | translate }}</button>
      </a>
    </div>
  </div>
</div>
